import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

export const NoaWidgetCard = styled.button`
  display: flex;
  align-items: center;
  gap: ${rem(16)};
  padding: ${rem(16)};
  border: ${rem(1)} solid ${({ theme }: any) => theme.colors.greyscale.gray15};
  border-radius: ${rem(4)};
  box-shadow: none;
  height: auto;
  min-height: 0;
  cursor: pointer;
  text-align: left;
  width: 100%;
  background: ${({ theme }) => theme.colors.greyscale.white};

  &:hover {
    background: ${({ theme }) => theme.colors.greyscale.gray2_5};
  }
`;

export const IconTile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${rem(40)};
  height: ${rem(40)};
  border-radius: ${rem(8)};
  background: ${({ theme }) => theme.colors.greyscale.gray5};
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(2)};
  flex: 1;
  min-width: 0;
`;

export const Title = styled.div`
  font-family: 'Gotham';
  font-size: ${rem(15)};
  font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
  color: ${({ theme }) => theme.colors.greyscale.gray50};
`;

export const Subtitle = styled.div`
  font-family: ${({ theme }) => theme.typography.fontFamilies.primary};
  font-size: ${rem(12)};
  color: ${({ theme }) => theme.colors.greyscale.gray40};
`;
